<template>
    <page break-before>
        <survey-subtitle>{{ $t(`${type}.${categoryKey}`, { context }) }}</survey-subtitle>
        <content-wrapper tag="p">{{ $t(`${type}.${categoryKey}_DESCRIPTION`, { context }) }}</content-wrapper>

        <div class="metadata-table-wrapper">
            <table :type="type">
                <thead>
                    <tr>
                        <th>{{ $t(`${type}.${categoryKey}_NAME`, { context }) }}</th>
                        <th
                            v-for="section in scores[0].sections"
                            :key="`table_${section.category}`"
                            v-tooltip:grey="
                                $t(`${type}.${section.category}_ROLE_TITLE`, {
                                    context,
                                })
                            "
                        >
                            {{ $t(`${type}.${categoryKey}_${section.category}_ABBREVIATION`, { context }) }}
                        </th>
                        <th>{{ $t(`${type}.${categoryKey}_DISTRIBUTION`, { context }) }}</th>
                    </tr>
                </thead>
                <tr v-for="score in scores" :key="`table_${score.title}`">
                    <td>{{ translateTitle(score.title) }} ({{ score.groupSize }})</td>
                    <td v-for="section in score.sections" :key="`table_${section.category}`">
                        <survey-badge uppercase :variant="color(section.median)">
                            {{ section.median }}
                        </survey-badge>
                    </td>
                    <td>
                        <survey-badge uppercase :variant="distribution(score.distribution)">
                            {{ score.distribution.toLowerCase() }}
                        </survey-badge>
                    </td>
                </tr>
            </table>
        </div>
    </page>
</template>
<script src="./TeamTable.ts"></script>
<style lang="scss">
@import '@/scss/components/table';

.metadata-table-wrapper {
    @extend .survey-table-shared;
    table {
        tr {
            th,
            td {
                text-align: left;
                min-width: 50px;
                white-space: nowrap;
            }

            th:nth-child(n + 2),
            td:nth-child(n + 2) {
                width: 0;
                white-space: nowrap;
                text-align: center;
                vertical-align: middle;
            }
        }
    }
}
</style>
